var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 1c-4.962 0-9 4.038-9 9s4.038 9 9 9 9-4.038 9-9-4.038-9-9-9m0 1.385A7.606 7.606 0 0 1 17.615 10 7.606 7.606 0 0 1 10 17.615 7.606 7.606 0 0 1 2.385 10 7.606 7.606 0 0 1 10 2.385m0 2.077a3.47 3.47 0 0 0-3.462 3.461c0 1.05.49 1.982 1.234 2.618a4.85 4.85 0 0 0-2.618 4.305h1.384A3.45 3.45 0 0 1 10 11.385a3.45 3.45 0 0 1 3.461 3.461h1.385a4.85 4.85 0 0 0-2.618-4.305c.744-.636 1.233-1.569 1.233-2.618A3.47 3.47 0 0 0 10 4.462m0 1.384c1.155 0 2.077.922 2.077 2.077A2.067 2.067 0 0 1 10 10a2.067 2.067 0 0 1-2.077-2.077c0-1.155.922-2.077 2.077-2.077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserCircle);
export default ForwardRef;